// S1 of docs/plans/2026-08-27-video-versions-review-3-fixes.md (review finding
// 1, High). VerifiedPlayer.tsx used to gate its whole verifying branch on the
// VIDEO's own chain authority alone. That is wrong for a version that was
// never anchored itself but whose CONTAINER was: the container's on-chain
// version list is exactly what should tell a viewer "this is not the version
// the chain names" (the `unlisted` warning, decided in D1 of the previous
// remediation) — but with no authority to derive a PDA from, nothing ever
// mounted the hook that reads it. See the Architecture section "The viewer's
// version axis: read completely before accusing" for the full picture.
//
// This function is the whole of that gate, pulled out so the decision has a
// unit test independent of React: is there ANY authority to derive a chain
// read from at all? The video's own wins when both exist — what to do when
// they're present and DISAGREE is a separate question, decided in
// useVideoVerification's `containerReadAuthority` memo, not here.
export function verificationPointer(videoAuthority?: string, containerAuthority?: string): string | undefined {
  return videoAuthority ?? containerAuthority
}
